import { useTranslation } from "@coworker/locales";
import {
  FilterValue,
  GroupFilter,
  InputFilter,
  InputType,
  RowVisibility,
} from "../../shared/filters/types/filter";
import { usePickupLocationsFilter } from "./usePickupLocationsFilter";
import { useRefillLocationsFilter } from "./useRefillLocationsFilter";
import { useLocationsFilter } from "./useLocationsFilter";
import { GROUP_LOCATIONS_ID } from "../constants/filterIds";

export function useGroupLocationsFilter(
  filterValues: FilterValue[]
): GroupFilter {
  const { t } = useTranslation();

  // Each location filter determines its own enabled state based on task type config
  // This group filter aggregates them and enables if any child filter is enabled
  const filters: InputFilter[] = [
    usePickupLocationsFilter(filterValues),
    useRefillLocationsFilter(filterValues),
    useLocationsFilter(filterValues),
  ];
  const enabled = filters.reduce(
    (accumulator, filter) => (filter.enabled ? true : accumulator),
    false
  );

  return {
    inputType: InputType.Group,
    id: GROUP_LOCATIONS_ID,
    title: t("location3String"),
    enabled,
    filters,
    rowVisibility: RowVisibility.PillOnly,
  };
}
